import { currencySelectors } from '@/features/shared/currency-selectors';
import { useCurrencyStore } from '@/features/shared/currency-store';

/**
 * ISO 3166-1 alpha-2 code of the visitor's detected country, or `null` until
 * `RegionHydrator` has resolved it.
 */
export function useCountryISO(): string | null {
  return useCurrencyStore(currencySelectors.country);
}
